module.exports = __webpack_public_path__ + "static/media/Comic Sans MS.a50f9c96.ttf";